<template>
  <div>
    <el-input
      v-model="search"
      size="mini"
      placeholder="Введите для поиска"
      @input="searchit"
    />
    <el-table v-loading="loading" :data="tableData" style="width: 100%">
      <el-table-column label="ИНН" prop="inn" />
      <el-table-column label="Наименование" prop="org_name" />
      <el-table-column align="right">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleSelect(scope.row.id)">
            Выбрать
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <br />
    <br />
    <el-button type="primary" @click="dialog_add_contr = true">
      Добавить нового контрагента
    </el-button>

    <el-dialog
      title="Добавление нового контрагента"
      :visible="dialog_add_contr"
      width="30%"
      center
      :append-to-body="true"
      :close-on-click-modal="false"
      @close="dialog_add_contr = false"
    >
      <new-contragents @saved="handleSaveNewContragent" />
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import NewContragents from '@/components/Contragents/NewContragents'

export default {
  name: 'SelectContragent',
  components: { NewContragents },
  data() {
    return {
      search: '',
      dialog_add_contr: false,
    }
  },
  computed: {
    ...mapGetters({
      tableData: 'getContragents',
      loading: 'loadingContagents',
    }),
  },

  mounted() {
    this.$store.dispatch('fetchContragents')
  },
  methods: {
    searchit() {
      if (this.search.length > 2) {
        this.$store.dispatch('fetchContragents', { search: this.search })
      }
      if (this.search.length === 0) {
        this.$store.dispatch('fetchContragents')
      }
    },
    handleSaveNewContragent() {
      this.$store.dispatch('fetchContragents')
    },
    getFilterInn(state) {
      return keyword =>
        state.contragents1.items.filter(item => item.inn === keyword)
    },
    getFilterName(state) {
      return keyword =>
        state.contragents1.items.filter(
          item => item.org_name.indexOf(keyword) > -1,
        )
    },
    handleSelect(id) {
      this.$emit('selected', id)
    },
  },
}
</script>

<style scoped></style>
